import { SupportFormModalComponent } from './support-form-modal';

export const entryComponents = [SupportFormModalComponent];

export * from './support-form-modal/support-form-modal';
